import { createSlice } from "@reduxjs/toolkit";
import { blogCategory } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const blogCategorySlice = createSlice({
  name: "blogCategory",
  initialState: data,
  reducers: {
    blogCategorySlice(state) {
      state.isLoading = false;
    },
    blogCategorySliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    blogCategorySliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    blogCategorySliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const blogCategoryHandler = () => async (dispatch: any) => {
  try {
    dispatch(blogCategoryAction.blogCategorySlice());
    const response: any = await blogCategory();
    dispatch(blogCategoryAction.blogCategorySliceSuccess(response));
  } catch (e: any) {
    dispatch(blogCategoryAction.blogCategorySliceFailure(e?.response?.data?.message));
    dispatch(blogCategoryAction.blogCategorySliceReset());
  }
};
export default blogCategorySlice.reducer;
export const blogCategoryAction = blogCategorySlice.actions;
